import { Label, LabelFilter } from '@/model';
import api from '@/rest-api';
import labels from '@/store/labels';
import LabelsView from '@/views/LabelsView.vue';
import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'LabelsController',
  components: {
    LabelsView,
  },

  data() {
    return {
      loading: false,
      filter: {} as LabelFilter,
      usageCounts: {} as Record<number, number>,
    };
  },

  computed: {
    allLabels(): readonly Label[] {
      return labels.state.labels;
    },
  },

  async mounted() {
    if (localStorage.getItem('labelFilter')) {
      this.loadFilter();
    } else {
      this.resetFilter();
    }
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      const [, usage] = await Promise.all([
        labels.dispatch.all(),
        api.labelUsage(),
      ]);
      this.usageCounts = usage;
      this.loading = false;
    },
    async toggleSelectable(label: Label) {
      this.loading = true;
      try {
        await labels.dispatch.save({ ...label, selectable: !label.selectable });
      } finally {
        this.loading = false;
      }
    },
    onFilterChange(filter: LabelFilter) {
      this.filter = filter;
      localStorage.setItem('labelFilter', JSON.stringify(filter));
    },
    loadFilter() {
      const filter = localStorage.getItem('labelFilter');
      if (filter) {
        this.filter = JSON.parse(filter);
      }
    },
    resetFilter() {
      localStorage.removeItem('labelFilter');
      this.filter = {};
    },
  },

  render(create): VNode {
    return create(
      LabelsView, {
        props: {
          loading: this.loading,
          labels: this.allLabels,
          filter: this.filter,
          usageCounts: this.usageCounts,
        },
        on: {
          toggleSelectable: this.toggleSelectable,
          filterChange: this.onFilterChange,
          resetFilter: this.resetFilter,
          saved: this.load,
        },
      },
    );
  },
});
